<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/logo/logo.png" alt="register" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title">
                  <h4 class="mb-4">Criar uma Conta {{appName}}</h4>
                </div>
                <div class="clearfix">
                  <form @submit="registerUserSubmit">
                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="name"
                      type="name"
                      label-placeholder="Seu Nome"
                      placeholder="Seu Nome"
                      v-model.trim="name"
                      class="w-full mt-6"
                      autocomplete="name"
                    />
                    <span class="text-danger text-sm">{{ errors.first('name') }}</span>

                    <vs-input
                      v-validate="'required|email'"
                      data-vv-validate-on="blur"
                      name="email"
                      type="email"
                      label-placeholder="Seu Melhor Email"
                      placeholder="Seu Melhor Email"
                      v-model.trim="email"
                      class="w-full mt-6"
                      autocomplete="email"
                    />
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="whatsapp"
                      type="whatsapp"
                      label-placeholder="Seu WhatsApp"
                      placeholder="Seu WhatsApp"
                      v-model.trim="whatsapp"
                      class="w-full mt-6"
                      autocomplete="tel"
                    />
                    <span class="text-danger text-sm">{{ errors.first('whatsapp') }}</span>

                    <vs-button class="float-right mt-6" @click="registerUser" :disabled="!validateForm || loading">ACESSAR APP ESPIÃO</vs-button>
                    <button type="submit" style="display: none"></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      whatsapp: "",
      loading: false,
      affiliate: "",
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff)
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.name !== "" &&
        this.email !== "" &&
        this.whatsapp !== ""
      );
    }
  },
  methods: {
    registerUser() {
      if (!this.validateForm) return false;

      this.loading = true

      this.$api
        .post("/api/v1/auth/onboarding-v1-register", {
          name: this.name,
          whatsapp: this.whatsapp,
          email: this.email,
          affiliate: localStorage.getItem('aff') || null
        })
        .then((response) => {
          this.$vs.notify({
            time: 6000,
            text: "Sua conta foi criada com sucesso.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

            let Tawk_API = Tawk_API || {}
            Tawk_API.visitor = {
              email: this.email
            }

            this.$localStorage.set('token', response.data.access_token)
            this.$localStorage.set('userId', response.data.user_id)
            this.$localStorage.set(
              'userInfo',
              JSON.stringify({
                email: this.email,
                providerId: 'local',
                uid: 1
              })
            )

            this.$EventBus.$emit('userChanged')

            this.$router.push('/pages/onboarding-v1-thanks')
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            text: error.response.data.errors.join("<br>"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        })
        .finally(() => {
          this.loading = false
        });
    },
    registerUserSubmit(e) {
      this.registerUser();
      e.preventDefault();
    }
  }
};
</script>
